import { render, staticRenderFns } from "./MainPageNewCopy.vue?vue&type=template&id=7db837cc&scoped=true&"
import script from "./MainPageNewCopy.vue?vue&type=script&lang=js&"
export * from "./MainPageNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MainPageNewCopy.vue?vue&type=style&index=0&id=7db837cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db837cc",
  null
  
)

export default component.exports